'use client';

import { Moon, Sun, Monitor } from 'lucide-react';
import { useTheme } from 'next-themes';
import { useTranslations } from 'next-intl';
import { Button } from '@/components/ui/button';
import { track } from '@/lib/analytics/ym';
import { useHydrated } from '@/lib/use-hydrated';

const cycle = { light: 'dark', dark: 'system', system: 'light' } as const;

const icons = { light: Sun, dark: Moon, system: Monitor } as const;

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  const t = useTranslations('ThemeToggle');
  const mounted = useHydrated();

  if (!mounted) {
    return <Button variant="ghost" size="icon" aria-label={t('loading')} />;
  }

  const current = (theme ?? 'system') as keyof typeof cycle;
  const next = cycle[current];
  // Значок показывает следующую тему, как и подпись переключателя языка.
  const Icon = icons[next];

  return (
    <Button
      variant="ghost"
      size="icon"
      // Подпись называет и текущую тему, и следующую по циклу light → dark → system.
      aria-label={t(current)}
      title={t('title')}
      onClick={() => {
        track.themeToggle(current, next);
        setTheme(next);
      }}
    >
      <Icon className="h-5 w-5" />
    </Button>
  );
}
